<template>
    <section id="tour_booking_submission" class="booking_submission section_padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="mb20">
                        <div id="pass-adult-info" class="mb20">
                            <div id="bk-pass-all">
                                <div class="row list">
                                    <div v-for="(item, index) in passengers" :data-id="item.id" :data-type="item.type"
                                        :key="item.id" class="col-md-4 col-12 col-sm-12 mb15 pass-card"
                                        :disabled="isCardDisabled(item) ? 'disabled' : 'false'">
                                        <div class="pass-spec-container">
                                            <div class="not-pass"></div>
                                            <div class="row no-margin align">
                                                <div
                                                    class="col-md-12 col-sm-12 col-xs-12 col-12 p-0 no-padding col-middle">
                                                    <label>
                                                        <div class="pass-details">
                                                            <div class="right">
                                                                <div
                                                                    style="display: flex;justify-content: space-between;gap:8px;">
                                                                    <span class="clearfix no-margin w-100">
                                                                        {{ item.first_name }}
                                                                        {{ item.last_name }}
                                                                    </span>
                                                                    <div class="icheckbox_square-green"
                                                                        style="position: relative;">
                                                                        <label class="checkbox-container">
                                                                            <input type="checkbox" class="select-pass"
                                                                                :checked="isSelected(item)"
                                                                                @change="toggleSelection($event, item)">
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <span class="clearfix no-margin">
                                                                    {{ $t('Passport') }}
                                                                    ({{
                                                                        getCountriesByCode(item.passport_issuing_country)[$i18n.locale
                                                                        + '_label'] }})
                                                                </span>
                                                                <div
                                                                    style="display: flex;flex-wrap: wrap;-webkit-box-pack: justify;justify-content: space-between;">
                                                                    <div>
                                                                        {{ item.passport_number }}
                                                                    </div>
                                                                    <div class="memb">
                                                                        <a @click="toggle($event, index)"
                                                                            class="memb-icon"
                                                                            href="javascript:void(0);">
                                                                            <i class="light-icon-user-plus"></i>
                                                                            {{ $t('Airline membership') }}
                                                                        </a>
                                                                        <LvOverlayPanel ref="passenger" appendTo="body"
                                                                            :dismissable="false" id="overlay_panel"
                                                                            style="width: 450px">
                                                                            <form class="needs-validation" novalidate>
                                                                                <div class="row">
                                                                                    <div class="col-md-12">
                                                                                        <div class="form-group">
                                                                                            <label
                                                                                                class="primary-color mb-2">
                                                                                                {{ $t('Airline') }} :
                                                                                            </label>
                                                                                            <model-list-select
                                                                                                :list="options"
                                                                                                v-model="item.LoyaltyProgram[0].programOwner"
                                                                                                :placeholder="$t('select2')"
                                                                                                option-value="code"
                                                                                                :custom-text="codeNameAndDesc">
                                                                                            </model-list-select>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-md-12 mt-3">
                                                                                        <div class="form-group">
                                                                                            <label
                                                                                                class="primary-color mb-2">
                                                                                                {{
                                                                                                    $t('Membership number')
                                                                                                }} :
                                                                                            </label>
                                                                                            <input
                                                                                                v-model="item.LoyaltyProgram[0].id"
                                                                                                type="number"
                                                                                                class="form-control"
                                                                                                required>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-md-12 mt-3">
                                                                                        <lv-button
                                                                                            class="lv--success pull-right"
                                                                                            type="button"
                                                                                            icon="light-icon-square-plus"
                                                                                            :label="$t('add')"
                                                                                            @click="submitMemb(index)"
                                                                                            aria:haspopup="true"
                                                                                            aria-controls="overlay_panel"></lv-button>
                                                                                        <lv-button
                                                                                            class="lv--secondary pull-right ml-2 mr-2"
                                                                                            type="button"
                                                                                            icon="light-icon-square-x"
                                                                                            :label="$t('cancel')"
                                                                                            @click="cancelMemb(index)"
                                                                                            aria:haspopup="true"
                                                                                            aria-controls="overlay_panel"
                                                                                            outlined></lv-button>
                                                                                    </div>
                                                                                </div>
                                                                            </form>
                                                                        </LvOverlayPanel>
                                                                    </div>
                                                                    <div>
                                                                        {{ $t('Expires') }}
                                                                        <time>
                                                                            {{
                                                                                getFormattedDate(item.passport_expiry_date)
                                                                            }}
                                                                        </time>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 text-center mt-4">
                    <button type="button" class="btn btn_theme btn_md w-25 " @click="next_summary">
                        {{ $t('Next') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import $ from 'jquery';
import { toast } from 'vue3-toastify';
import jsonData from '@/assets/file/airlines-v2.json';
import countriesData from '@/assets/file/countries.json';
import guestService from '@/services/saudi-cup/guest/guest-service';
import groupService from '@/services/saudi-cup/group/group-service';
import { diffYears, formatDate } from '@/utils/dateUtils';
import LvOverlayPanel from 'lightvue/overlay-panel';
import { ModelListSelect } from 'vue-search-select';
import LvButton from 'lightvue/button';

export default {
    name: 'FlightPassengersArea',
    data: () => ({
        options: [],
        passengers: [],
        adults: [],
        infants: [],
        children: [],
        years: [],
        searchData: [],
    }),
    components: {
        LvOverlayPanel,
        LvButton,
        ModelListSelect,
    },
    methods: {
        codeNameAndDesc(item) {
            return `${item[this.$i18n.locale + '_name']} (${item.code})`
        },
        toggle(event, index) {
            this.$refs.passenger[index].toggle(event);
        },
        cancelMemb(index) {
            this.$refs.passenger[index].hide();
            this.passengers[index]['LoyaltyProgram'] = [{ "programOwner": null, "id": null }];
        },
        submitMemb(index) {
            var forms = document.querySelectorAll('.needs-validation')
            forms[0].classList.add('was-validated');
            if (!forms[0].checkValidity() || !this.passengers[index].LoyaltyProgram[0].programOwner) {
                toast.error(this.$t('All fields are required'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
                return;
            }
            this.$refs.passenger[index].hide();
        },
        getCountriesByCode(code) {
            var info = countriesData.filter(item => {
                return item.en_label.includes(code);
            });
            return info[0];
        },
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        diff_years(dt2, dt1) {
            return diffYears(dt2, dt1);
        },
        next_summary() {
            const pass = [this.adults, this.infants, this.children];
            var passengers = pass.flat();
            var adult = this.searchData.adults,
                child = this.searchData.children,
                infant = this.searchData.infants;
            if (adult + child + infant != passengers.length) {
                toast.error(this.$t('Please select passenger(s)'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
                return;
            }
            this.passengers = this.passengers.filter((item) => {
                return passengers.includes(item.id);
            });
            passengers = [];
            this.passengers.forEach(element => {
                passengers.push(element.encrypted_id);
            });
            localStorage.setItem('passengers', JSON.stringify(passengers));
            localStorage.setItem('passengersDetails', JSON.stringify(this.passengers));
            this.$router.push(`/flight-confirmation`);
        },
        toggleSelection(event, item) {
            const isChecked = event.target.checked;
            const type = item.type;
            if (isChecked) {
                if (type === 'Adult') this.adults.push(item.id);
                else if (type === 'Child') this.children.push(item.id);
                else if (type === 'Infant') this.infants.push(item.id);
            } else {
                if (type === 'Adult') this.removeItem(this.adults, item.id);
                else if (type === 'Child') this.removeItem(this.children, item.id);
                else if (type === 'Infant') this.removeItem(this.infants, item.id);
            }
        },
        removeItem(list, id) {
            const index = list.indexOf(id);
            if (index > -1) list.splice(index, 1);
        },
        isSelected(item) {
            if (item.type === 'Adult') return this.adults.includes(item.id);
            if (item.type === 'Child') return this.children.includes(item.id);
            if (item.type === 'Infant') return this.infants.includes(item.id);
            return false;
        },
        isCardDisabled(item) {
            const type = item.type;
            if (type === 'Adult') return !this.adults.includes(item.id) && this.adults.length >= this.searchData.adults;
            if (type === 'Child') return !this.children.includes(item.id) && this.children.length >= this.searchData.children;
            if (type === 'Infant') return !this.infants.includes(item.id) && this.infants.length >= this.searchData.infants;
            return false;
        },
    },
    mounted() {
        $('.pre-loader').show();
        this.options = jsonData;
        this.adults = [];
        this.children = [];
        this.infants = [];
        this.searchData = JSON.parse(localStorage.getItem("searchData"));
        localStorage.removeItem("is_bags_confirmed");

        const guest_id = localStorage.getItem("guest_id");
        const user_token = localStorage.getItem("user_token");
        const group_id = localStorage.getItem("group_id");
        if (guest_id) {
            guestService.guest_by_encrypted_id(guest_id).then(response => {
                const data = response.data.data, guest = data.guest, policy = data.policy;
                if (!guest.flight) {
                    if (guest.data_status == "Complete") {
                        var dt1 = new Date(guest.birthdate);
                        var dt2 = new Date();
                        var interval = this.diff_years(dt1, dt2);
                        var type = '';

                        if (interval <= 2) {
                            type = 'Infant';
                        } else if (interval <= 11) {
                            type = 'Child';
                        } else {
                            type = 'Adult';
                        }
                        this.passengers.push({
                            "id": guest.id,
                            "encrypted_id": guest.encrypted_id,
                            "type": type,
                            "title": guest.gender == 'Female' ? 'ms' : 'mr',
                            "first_name": guest.en_first_name,
                            "last_name": guest.en_last_name,
                            "registration_number": guest.registration_number,
                            "category": guest.category.en_name,
                            "birthday": guest.birthdate,
                            "email": guest.email,
                            "mobile": guest.mobile,
                            "nationality": guest.nationality.code,
                            "passport_number": guest.passport_number,
                            "passport_issue_date": guest.passport_issue_date,
                            "passport_issuing_country": guest.place_of_passport_issue,
                            "passport_expiry_date": guest.passport_expire_date,
                            "LoyaltyProgram": [{ "programOwner": null, "id": null }],
                        });

                        var passenger_count = this.searchData.adults
                            + this.searchData.children
                            + this.searchData.infants;

                        if (passenger_count > 1) {
                            guest.companions.forEach(element => {
                                if (element.data_status == "Complete" && !element.flight) {
                                    var dt1 = new Date(element.birthdate);
                                    var dt2 = new Date();
                                    var interval = this.diff_years(dt1, dt2);
                                    var type = '';

                                    if (interval <= 2) {
                                        type = 'Infant';
                                    } else if (interval <= 11) {
                                        type = 'Child';
                                    } else {
                                        type = 'Adult';
                                    }
                                    this.passengers.push({
                                        "id": element.id,
                                        "encrypted_id": element.encrypted_id,
                                        "type": type,
                                        "title": element.gender == 'Female' ? 'ms' : 'mr',
                                        "first_name": element.en_first_name,
                                        "last_name": element.en_last_name,
                                        "registration_number": element.registration_number,
                                        "category": element.category.en_name,
                                        "birthday": element.birthdate,
                                        "email": element.email,
                                        "mobile": element.mobile,
                                        "nationality": element.nationality.code,
                                        "passport_number": element.passport_number,
                                        "passport_issue_date": element.passport_issue_date,
                                        "passport_issuing_country": element.place_of_passport_issue,
                                        "passport_expiry_date": element.passport_expire_date,
                                        "LoyaltyProgram": [{ "programOwner": null, "id": null }],
                                    });
                                }
                            });
                        }
                    }
                } else {
                    this.$router.replace('/booking-details');
                }
                $('.pre-loader').hide();
            });
        } else if (user_token) {
            groupService.get_flight_group_id(group_id).then((response) => {
                const data = response.data.data,
                    guests = data.guests;
                guests.members.forEach(element => {
                    if (element.data_status == "Complete" && !element.flight) {
                        var dt1 = new Date(element.birthdate);
                        var dt2 = new Date();
                        var interval = this.diff_years(dt1, dt2);
                        var type = '';

                        if (interval <= 2) {
                            type = 'Infant';
                        } else if (interval <= 11) {
                            type = 'Child';
                        } else {
                            type = 'Adult';
                        }
                        this.passengers.push({
                            "id": element.id,
                            "encrypted_id": element.encrypted_id,
                            "type": type,
                            "title": element.gender == 'Female' ? 'ms' : 'mr',
                            "first_name": element.en_first_name,
                            "last_name": element.en_last_name,
                            "registration_number": element.registration_number,
                            "category": element.category.en_name,
                            "birthday": element.birthdate,
                            "email": element.email,
                            "mobile": element.mobile,
                            "nationality": element.nationality.code,
                            "passport_number": element.passport_number,
                            "passport_issue_date": element.passport_issue_date,
                            "passport_issuing_country": element.place_of_passport_issue,
                            "passport_expiry_date": element.passport_expire_date,
                            "LoyaltyProgram": [{ "programOwner": null, "id": null }],
                        });
                    }
                });
                $('.pre-loader').hide();
            });
        } else {
            $('.pre-loader').hide();
            this.$router.replace(`/error`);
        }

    },
}
</script>
<style lang="scss">
@import url('@/assets/style/flight-passengers.scss');
</style>